// extracted by mini-css-extract-plugin
export default {"card":"BlogCard_card__zGQr7","image":"BlogCard_image__jZDE7","label":"BlogCard_label__OM2cp","link":"BlogCard_link__KfjtX"};